/// <amd-module name="Artifacts/FeedPicker/components/FeedPicker" />

import * as R from "Artifacts/FeedPicker/Resources";
import { ComponentState } from "Artifacts/Root/Constants";
import { isReady } from "Artifacts/Root/helpers/ComponentStateHelpers";
import { IFeedIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { Dropdown, IDropdownPivot, IWithPivotsChildProps, WithPivots } from "VSSUI/Dropdown";
import { IListBoxItem } from "VSSUI/ListBox";
import { AggregateItemProvider } from "VSSUI/Utilities/AggregateItemProvider";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";
import { Location } from "VSSUI/Utilities/Position";

interface IFeedPickerProps {
  pivots: IDropdownPivot<IFeedIdentity>[];
  selectedPivot: IDropdownPivot<IFeedIdentity>;
  onPivotClicked: (pivot: IDropdownPivot<IFeedIdentity>) => void;
  dropdownProvider: AggregateItemProvider<IListBoxItem<IFeedIdentity>>;
  componentState: ComponentState;
  selection: DropdownSelection;
  onSelect: (
    event: React.SyntheticEvent<HTMLElement, Event>,
    item: IListBoxItem<IFeedIdentity>,
  ) => void;
}

const FeedPicker: React.FC<IFeedPickerProps> = ({
  pivots,
  selectedPivot,
  onPivotClicked,
  dropdownProvider,
  componentState,
  selection,
  onSelect,
}) => {
  return (
    <>
      <WithPivots
        calloutProps={{
          title: R.FeedPicker_Title,
          dropdownOrigin: {
            horizontal: Location.start,
            vertical: Location.start,
          },
          anchorOrigin: {
            horizontal: Location.start,
            vertical: Location.end,
          },
        }}
        pivots={pivots}
        selectedPivot={selectedPivot.id}
        onPivotClicked={onPivotClicked}
      >
        {(props: IWithPivotsChildProps) => (
          <Dropdown
            className={"feed-picker"}
            calloutContentClassName={"feed-picker-callout"}
            containerClassName={"feed-picker-container"}
            loading={!isReady(componentState)}
            ariaLabel={R.FeedPicker_AriaLabel}
            items={dropdownProvider}
            onSelect={onSelect}
            selection={selection}
            {...props}
          />
        )}
      </WithPivots>
    </>
  );
};

export { FeedPicker };
